import "bootstrap/dist/css/bootstrap.min.css";
import About from "./components/About/About";
import Contact from "./components/Contact/Contact";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import Hero from "./components/Hero/Hero";
import Resume from "./components/Resume/Resume";
import Skills from "./components/Skills/Skills";
// import Works from "./components/Works/Works";
import Email from "./components/Email/Email";
// import Projects from "./components/Projects/Projects";
import Laravel from "./components/Laravel/Laravel";
import Html from "./Html/Html";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <About />
      <Skills />
      {/* <Projects /> */}
      {/* <Works /> */}
      <Laravel />
      <Html />
      <Resume />
      <Contact />
      <Email />
      <Footer />
      {/* <ToastContainer /> */}
    </div>
  );
}

export default App;
